import React, { useState } from 'react';

function MAFTools() {
  

  
  return (
    <div className="maf-tools">
        <iframe
  src="https://xiyas.shinyapps.io/maftools"
  width="100%"
  height="800"
  style={{ border: 'none' }}
/>
    </div>
  );
}




export default MAFTools;

